import React from 'react'
import createIcon from '@/lib/create-icon'

export const GlobeSVGIcon = createIcon(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1866_12094)">
      <path d="M14.6663 7.99998C14.6663 11.6819 11.6816 14.6666 7.99967 14.6666M14.6663 7.99998C14.6663 4.31808 11.6816 1.33331 7.99967 1.33331M14.6663 7.99998H1.33301M7.99967 14.6666C4.31778 14.6666 1.33301 11.6819 1.33301 7.99998M7.99967 14.6666C9.66719 12.8411 10.6148 10.472 10.6663 7.99998C10.6148 5.528 9.66719 3.15888 7.99967 1.33331M7.99967 14.6666C6.33215 12.8411 5.38451 10.472 5.33301 7.99998C5.38451 5.528 6.33215 3.15888 7.99967 1.33331M1.33301 7.99998C1.33301 4.31808 4.31778 1.33331 7.99967 1.33331" stroke="#0B947C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1866_12094">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>,

)
